import { useIsMobile } from "../../../hooks/useIsMobile";
import { Mobile } from "./mobile";
import { Desktop } from "./desktop";
import styles from "./index.module.scss";

export const Header = () => {
    const isMobile = useIsMobile();

    return (
        <div className={styles.header}>
            {isMobile ? <Mobile/> : <Desktop/>}
        </div>
    );
};